import React, { useState } from 'react';
import { useData } from '../../context/DataContext';
import QuadrantPlot from './QuadrantPlot';
import TransformationVolcano from './TransformationVolcano';
import EnrichmentTable from './EnrichmentTable';
import GnaPathwayTable from './GnaPathwayTable';

const SUB_VIEWS = [
  { id: 'quadrant', label: 'Quadrant' },
  { id: 'volcano', label: 'Volcano' },
  { id: 'enrichment', label: 'Enrichment' },
  { id: 'gna', label: 'GNA Pathway' },
];

export default function TransformationView({ onSelectGene }) {
  const { data } = useData();
  const [subView, setSubView] = useState('quadrant');
  const [infoOpen, setInfoOpen] = useState(false);

  const transformation = data?.transformation;

  if (!transformation) {
    return (
      <div className="transformation-view">
        <div className="transformation-no-data">
          <h3>Transformation data not available</h3>
          <p>Run <code>python scripts/export_transformation.py</code> to generate the data.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="transformation-view">
      <div className="transformation-header">
        <div className="transformation-subviews">
          {SUB_VIEWS.map(v => (
            <button
              key={v.id}
              className={subView === v.id ? 'active' : ''}
              onClick={() => setSubView(v.id)}
            >
              {v.label}
            </button>
          ))}
        </div>

        <button
          className="transformation-info-toggle"
          onClick={() => setInfoOpen(!infoOpen)}
        >
          {infoOpen ? 'Hide Info' : 'About'}
        </button>
      </div>

      {infoOpen && (
        <div className="transformation-info-banner">
          <p>
            <strong>EZH2-Y641F/BCL2 Transformation Analysis</strong> &mdash;
            The EmBO GEMM (Isshiki '25) models FL-to-DLBCL progression via serial
            transplantation. P0 (GCB_Ezh2BCL2, pre-malignant) transforms to P6
            (tFL, DLBCL-like) over 6 passages.
          </p>
          <p>
            <strong>Quadrant view</strong> classifies genes by their transformation
            behavior (P0&rarr;P6) and response to EZH2 inhibition (tazemetostat).
            EZH2-sensitive genes are reversed by tazemetostat; insensitive genes
            reflect transcriptional program collapse.
          </p>
          <p>
            <strong>Source:</strong> Limma eBayes on log2(TPM+1). 4,666 DEGs classified.
            H3K27me3 CUT&amp;RUN data for pathway genes.
          </p>
        </div>
      )}

      <div className="transformation-content">
        {subView === 'quadrant' && (
          <QuadrantPlot
            sensitivity={transformation.sensitivity}
            onSelectGene={onSelectGene}
          />
        )}
        {subView === 'volcano' && (
          <TransformationVolcano
            sensitivity={transformation.sensitivity}
            onSelectGene={onSelectGene}
          />
        )}
        {subView === 'enrichment' && (
          <EnrichmentTable
            enrichment={transformation.enrichment}
            onSelectGene={onSelectGene}
          />
        )}
        {subView === 'gna' && (
          <GnaPathwayTable
            gnaPathway={transformation.gnaPathway}
            onSelectGene={onSelectGene}
          />
        )}
      </div>
    </div>
  );
}
